import React, { useState, useRef, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { getListTicket, updateDataSearch } from "../../../actions/Ticket";
import { Headersubfull } from "../../GenericComponent/HeaderSubFull/headersubfull";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { SearchBarMobile } from "./SearchBarMobile";
import { useSelector, useDispatch } from "react-redux";
import { TableDanhSach } from "./TableDanhSach";
import { AddTaiKhoanBtn } from "./AddTaiKhoanBtn";
import StoreApi from "service/phanQuyenApi";
import { AddTaiKhoanDesktopBtn } from "./AddTaiKhoanDesktopBtn.js";
import DanhDachIcloudApi from "../../../service/QuanTriHeThong/DanhDachIcloudApi";
import LayoutV2 from "containers/LayoutV2";

export const TaiKhoanIcloud = () => {
  const dispatch = useDispatch();
  const [dataTaiKhoan, setDataTaiKhoan] = useState({});
  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanIcloud);
  const initPhanQuyen = {
    taikhoanicloud_danhsach: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  useEffect(() => {
    document.title =
      "Quản lý tài khoản ICloud | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
    onSearch();
  }, []);
  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenTaiKhoanIcloud().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        taikhoanicloud_danhsach: response.data.taikhoanicloud_danhsach,
      });
    });
  };
  const onSearch = () => {
    DanhDachIcloudApi.list({
      SoDienThoai: dataSearch.SoDienThoai,
      TenTaiKhoan: dataSearch.TenTaiKhoan,
      SoHDLienKet: dataSearch.SoHDLienKet,
      iHanChe: dataSearch.iHanChe,
      iLock: dataSearch.iLock,
      iPageSize: dataSearch.iPageSize,
      iPageIndex: dataSearch.iPageIndex,
    }).then((response) => {
      if (response.status == "200") {
        setDataTaiKhoan(response.data);
      }
    });
  };
  return (
    <LayoutV2>
      {phanQuyen.taikhoanicloud_danhsach && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/icon-logo-quan-ly-thu-chi.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                            Quản lý tài khoản ICloud
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop onSearch={onSearch} />
                  </div>
                </div>
              </div>
              <AddTaiKhoanBtn data={""} onSearch={onSearch} />
              <SearchBarMobile onSearch={onSearch} />
              {/* <AddTaiKhoanDesktopBtn data={""} onSearch={onSearch} /> */}
            </div>
          </div>
          <TableDanhSach dataDanhSach={dataTaiKhoan} onSearch={onSearch} />
        </div>
      )}
      {!phanQuyen.taikhoanicloud_danhsach && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/icon-logo-quan-ly-thu-chi.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                            Quản lý tài khoản ICloud
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
